import { useEffect, useState } from "react";
import { fetchPulse } from "@/lib/theories";

export default function CrowdPulse() {
  const [pulse, setPulse] = useState(null);

  useEffect(() => {
    let live = true;
    const load = () => fetchPulse().then((p) => live && setPulse(p)).catch(() => {});
    load();
    const t = setInterval(load, 60_000);
    return () => {
      live = false;
      clearInterval(t);
    };
  }, []);

  if (!pulse) return null;
  return (
    <span
      data-testid="crowd-pulse"
      title={`${pulse.today} today · ${pulse.total} all time`}
      className="hidden items-center gap-2 whitespace-nowrap font-mono text-[9px] tracking-[0.22em] text-white/50 lg:flex"
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#FF9F1C] opacity-60" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#FF9F1C]" />
      </span>
      <span data-testid="crowd-pulse-week" className="text-[#F8FAFC]/80">
        {pulse.week}
      </span>
      VOTES THIS WEEK
    </span>
  );
}
